const initial_undo = {
    undo_data:{
        history:[],
        index:0,
    }
}

export default initial_undo